module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "not-available"
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('web.reward_unavailable.unavailable')))]), _vm._v(" "), _c('div', {
    staticClass: "links"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Rewards'
      }
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t('web.reward_unavailable.rewards_list_link')) + "\n    ")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4e73a7e1"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/RewardUnavailable.vue
// module id = 534
// module chunks = 1